import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'

// Dayjs の言語設定もインポートしておく、app.vue で VueI18n と同期する
import 'dayjs/locale/ja'
import 'dayjs/locale/en'
import 'dayjs/locale/th'
import 'dayjs/locale/vi'

dayjs.extend(utc) // dayjsのutcプラグインを有効化

export default defineNuxtPlugin(() => {
  // dayjs の設定（utc プラグイン有効化・locale 登録）は
  // モジュールスコープで完了済みのため、ここでは何もしない
})
